const user = {
  state: {
    au: null,
    managerInfo: {},
  },
  mutations: {
    CHANGEAU(state, au) {
      state.au = au;
    },
    CHANGEMANAGERINFO(state, data) {
      state.managerInfo = data;
    },
  },
  actions: {
    changeAu({ commit }, au) {
      return new Promise((resolve) => {
        commit('CHANGEAU', au);
        resolve();
      });
    },
    changeManagerInfo({ commit }, data) {
      return new Promise((resolve) => {
        commit('CHANGEMANAGERINFO', data);
        resolve();
      });
    },
  },
};

export default user;
